import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from './ui/sheet';
import BomForm from './BomForm';

/**
 * BOM Creation Drawer - A Sheet-based drawer for creating BOMs.
 *
 * Uses Radix UI Sheet (DialogPrimitive) with Portal.
 * Kept as a separate component to isolate rendering from
 * ProductionDetailPage's complex state/render cycle.
 */
function BomCreationDrawer({ open, onOpenChange, finishedProduct, onSuccess, onCancel }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-[90vw] max-w-5xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>快速创建BOM</SheetTitle>
          <SheetDescription>
            {finishedProduct
              ? `为产品 ${finishedProduct.product_code} 创建物料清单。`
              : '创建物料清单'}
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6">
          {finishedProduct && (
            <BomForm
              finishedProduct={finishedProduct}
              onSuccess={onSuccess}
              onCancel={onCancel}
            />
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}

export default React.memo(BomCreationDrawer);
